
export interface ICenterType {
    centerTypeId: number;
    description: string;
}